var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGroup = function SvgGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    color: "#fff",
    viewBox: "0 0 40 39"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.966,
    cy: 3.621,
    r: 3.621
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.345 22.931v7.845c0 1 .81 1.81 1.81 1.81h3.62c1 0 1.811-.81 1.811-1.81V22.93h1.81c1 0 1.81-.81 1.81-1.81v-8.449c0-1-.81-1.81-1.81-1.81H23.535c-1 0-1.81.81-1.81 1.81v.604"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.241,
    cy: 3.621,
    r: 3.621
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.483 12.672c0-1-.81-1.81-1.81-1.81H1.81c-1 0-1.81.81-1.81 1.81v8.449c0 1 .81 1.81 1.81 1.81h1.81v7.845c0 1 .811 1.81 1.811 1.81h3.62c1 0 1.811-.81 1.811-1.81V22.93"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.103,
    cy: 6.034,
    r: 3.621
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.534 13.276H12.672c-1 0-1.81.81-1.81 1.81v8.448c0 1 .81 1.81 1.81 1.81h1.81v7.846c0 1 .811 1.81 1.811 1.81h3.62c1 0 1.811-.81 1.811-1.81v-7.845h1.81c1 0 1.81-.81 1.81-1.81v-8.449c0-1-.81-1.81-1.81-1.81"
  }))));
};
export default SvgGroup;